import { getEnterpriseAddressInfo } from '@/api/user'
import { isLogin } from '@/features/user'

export default {
  methods: {
    //  获取并设定经营地址
    async $_orderMixin_judgeIsGetHistoryEnterpriseAddressInfo({
      form,
      locationKeyName,
      locationDetailKeyName,
      enterpriseName
    } = {}) {
      if (!isLogin()) {
        form[locationKeyName] = [this.cityInfo.city.id, this.cityInfo.district.id]
        return
      }
      //  当前已选则经营地址时，不进行反显
      //   if (form[locationKeyName] && Object.keys(form[locationKeyName]).length > 0) return
      // 当前无输入企业名称 或 用户信息无企业名称字段

      const curEnterpriseName = enterpriseName || this.$store.state.user?.userInfo?.companyName
      //   if (!curEnterpriseName) return

      const {
        foundLocation,
        foundDetailAddress
      } = await this.$_orderMixin_getEnterpriseAddressInfo(curEnterpriseName)
      if (foundLocation) {
        form[locationKeyName] = foundLocation
      }
      if (foundDetailAddress && locationDetailKeyName) {
        form[locationDetailKeyName] = foundDetailAddress
      }
    },
    // 请求接口并格式化
    async $_orderMixin_getEnterpriseAddressInfo(enterpriseName) {
      const result = await getEnterpriseAddressInfo({ enterpriseName })
        .then(res => {
          if (res.data.code === 4002) {
            this.$store.dispatch('user/getUserToken')
            return
          }
          if (res.data.code !== 0) return

          const { enterpriseCityId, enterpriseDistrictId, enterpriseDetailAddress } = res.data.data

          const areaIdList = [enterpriseCityId, enterpriseDistrictId]

          return this.formatAreaData({
            locationIds: areaIdList,
            detailAddressName: enterpriseDetailAddress
          })
        })
        .catch(() => {})

      return result
    },
    // 将地区id 和名称格式化成表单所需数据格式
    formatAreaData ({ locationIds, detailAddressName }) {
      return {
        foundLocation: locationIds,
        foundDetailAddress: detailAddressName
      }
    }
  }
}
